import React from "react";
import { Switch, Route } from "react-router-dom";
import Sidebar from "pages/dashboard/components/Sidebar";
import { Dashboard } from "pages/dashboard/main";
import Sessions from "pages/dashboard/Sessions";
import { Queue } from "pages/dashboard/queue";
import Instances from "pages/dashboard/Instances";
import Pricing from "pages/dashboard/Pricing";
import { E404 } from "pages/error/E404";

const DashboardLayout = () => (

    <Sidebar>
        <Switch>
            <Route path="/dashboard" exact component={Dashboard}/>
            <Route path="/dashboard/sessions" exact component={Sessions}/>
            <Route path="/dashboard/queue" exact component={Queue}/>
            <Route path="/dashboard/instances" exact component={Instances}/>
            <Route path="/dashboard/pricing" exact component={Pricing}/>
            <Route component={E404}/>
        </Switch>
    </Sidebar>

);

export default DashboardLayout;
